import 'css-chunksrc/client/pages/planzoneMembersPage/resource/subordinates/styles.scss';export default {
  "subordinates": "_subordinates_qyzkq_1",
  "list": "_list_qyzkq_8",
  "item": "_item_qyzkq_15",
  "infoBubble": "_infoBubble_qyzkq_22",
  "slideIn": "_slideIn_qyzkq_1",
  "avatar": "_avatar_qyzkq_28",
  "summary": "_summary_qyzkq_33",
  "addAllocation": "_addAllocation_qyzkq_62",
  "iconBox": "_iconBox_qyzkq_67",
  "icon": "_icon_qyzkq_67",
  "clearButton": "_clearButton_qyzkq_79",
  "selectList": "_selectList_qyzkq_90",
  "compact": "_compact_qyzkq_104"
};